<template>
  <div class="app-container">
    <div class="full-height">
      <!-- 商家 -->
      <el-dialog
        v-loading="formLoading"
        top="2%"
        :title="!formData.id ? '建立商家' : '商家維護'"
        :visible.sync="dialogFormVisible"
        append-to-body
        show-close
      >
        <el-row>
          <el-col :span="24">
            <el-card class="box-card">
              <div class="advertise-data">
                <el-form ref="companyForm" :model="formData">
                  <el-form-item prop="fileInfo" style="margin-bottom: 30px">
                    <Upload
                      ref="uploadLogoRef"
                      :require="true"
                      :limit-file-count="1"
                      :payload="formData"
                      :accept="'.jpg,.jpeg,.png'"
                      :data-obj="{ id: 43, type: 'companyLogo' }"
                      :use-drag="false"
                      :action="'file/fileUploadLogo'"
                      :auto-upload="false"
                      :show-file-list="true"
                      :form-on-loading-parent="formLoading"
                      :btn-txt="'上傳'"
                      :before-file-list="
                        formData.fileInfo && formData.fileInfo.length
                          ? formData.fileInfo[0].files
                          : []
                      "
                      :limitText="'顯示圖片最佳尺寸為500x500大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                    />
                  </el-form-item>
                  <el-form-item
                    label="公司名稱"
                    :label-width="formLabelWidth"
                    prop="name"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入公司名稱',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.name" autocomplete="off" />
                  </el-form-item>

                  <el-form-item
                    label="統一編號"
                    :label-width="formLabelWidth"
                    prop="vatNumber"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入統一編號',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.vatNumber" autocomplete="off" />
                  </el-form-item>

                  <el-form-item
                    label="負責人"
                    :label-width="formLabelWidth"
                    prop="boss"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入負責人',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.boss" autocomplete="off" />
                  </el-form-item>

                  <el-form-item
                    label="Email"
                    :label-width="formLabelWidth"
                    prop="email"
                    :rules="[
                      {
                        required: false,
                        pattern: pattern.email,
                        message: 'Email格式不正確',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.email" autocomplete="off" />
                  </el-form-item>
                  <el-form-item label="電話" :label-width="formLabelWidth" prop="tel">
                    <el-input v-model="formData.tel" autocomplete="off" />
                  </el-form-item>
                  <el-form-item
                    label="地址"
                    :label-width="formLabelWidth"
                    prop="address"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入地址',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.address" autocomplete="off" />
                  </el-form-item>
                  <el-form-item
                    label="簽約期間"
                    :label-width="formLabelWidth"
                    prop="signDate"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入簽約期間',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="formData.signDate"
                      type="daterange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="開始日期"
                      end-placeholder="結束日期"
                      value-format="yyyy-MM-dd"
                      class="w-full-date"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item
                    label="官方網址"
                    :label-width="formLabelWidth"
                    prop="url"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入官方網址',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.url" autocomplete="off" />
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="warning" @click="saveData('companyFormData')" style="color: #4b4b4b"
            >儲 存</el-button
          >

          <el-button @click="dialogFormVisible = false"> 取 消 </el-button>
        </div>
      </el-dialog>

      <!-- 廣告 -->
      <el-dialog
        top="2%"
        append-to-body
        :title="!adFormData.id ? '新增廣告' : '廣告詳情'"
        :visible.sync="dialogAdViewVisible"
        width="50%"
      >
        <el-card class="box-card">
          <el-form
            ref="adForm"
            :model="adFormData"
            :label-width="formLabelWidth"
            label-position="right"
            :disabled="adFormData.status == 3"
          >
            <el-form-item
              label="廣告名稱"
              prop="name"
              :rules="[
                {
                  required: true,
                  message: '請輸入廣告名稱',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="adFormData.name" placeholder="廣告名稱" />
            </el-form-item>

            <el-form-item
              label="廣告副標題"
              prop="subTitle"
              :rules="[
                {
                  required: true,
                  message: '請輸入廣告副標題',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="adFormData.subTitle" placeholder="廣告副標題" />
            </el-form-item>

            <el-form-item label="優惠碼" prop="code">
              <el-input v-model="adFormData.code" placeholder="優惠碼" />
            </el-form-item>

            <el-form-item
              label="廣告描述"
              prop="description"
              :rules="[
                {
                  required: true,
                  message: '請輸入廣告描述',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="adFormData.description"
                :autosize="{ minRows: 6, maxRows: 8 }"
                type="textarea"
                placeholder="廣告描述"
              />
            </el-form-item>
            <el-form-item
              label="廣告期間"
              :label-width="formLabelWidth"
              prop="adDate"
              :rules="[
                {
                  required: true,
                  message: '請輸入簽約期間',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="adFormData.adDate"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
                value-format="yyyy-MM-dd"
                class="w-full-date"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="狀態">
              <el-switch
                v-model="adFormData.enable"
                active-text="啟用"
                inactive-text="停用"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button
            v-if="adFormData.status != 3"
            type="warning"
            @click="handleSaveAdData"
            style="color: #4b4b4b"
            >儲 存</el-button
          >
          <el-button
            @click="dialogAdViewVisible = false"
            :type="adFormData.status == 3 ? 'danger' : ''"
          >
            {{ adFormData.status == 3 ? '關 閉' : '取 消' }}</el-button
          >
        </span>
      </el-dialog>

      <!-- 版位 -->
      <el-dialog
        v-loading="formLoading"
        top="2%"
        :title="!formAdPositionData.id ? '建立廣告版位' : '廣告版位維護'"
        :visible.sync="dialogAdSlotVisible"
        append-to-body
        show-close
        width="60%"
      >
        <el-card class="box-card">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="advertise-data">
                <el-card class="box-card" v-if="selectedAdRow" style="margin-bottom: 24px">
                  <el-descriptions title="" :column="1" size="small" border>
                    <el-descriptions-item>
                      <template slot="label"> 廣告標題 </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="selectedAdRow.name"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <span>
                          {{ selectedAdRow.name }}
                        </span>
                        <div class="copy-icon" v-show="!!selectedAdRow.name">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 廣告副標題 </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="selectedAdRow.subTitle"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <span>
                          {{ selectedAdRow.subTitle }}
                        </span>
                        <div class="copy-icon" v-show="!!selectedAdRow.subTitle">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 廣告描述 </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="selectedAdRow.description"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <span>
                          {{ selectedAdRow.description }}
                        </span>
                        <div class="copy-icon" v-show="!!selectedAdRow.description">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label"> 優惠碼 </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="selectedAdRow.code"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <span>
                          {{ selectedAdRow.code }}
                        </span>
                        <div class="copy-icon" v-show="!!selectedAdRow.code">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>

                    <el-descriptions-item>
                      <template slot="label"> 廣告期間 </template>
                      <el-tag size="small">
                        {{ `${selectedAdRow.startDate} 至 ${selectedAdRow.endDate}` }}
                      </el-tag>
                    </el-descriptions-item>

                    <el-descriptions-item>
                      <template slot="label"> 狀態 </template>
                      <el-tag
                        size="small"
                        :type="
                          selectedAdRow.status == 1
                            ? 'warning'
                            : selectedAdRow.status == 2
                              ? 'success'
                              : selectedAdRow.status == 3
                                ? 'info'
                                : 'danger'
                        "
                      >
                        <span>{{
                          selectedAdRow.status == 1
                            ? '未開始'
                            : selectedAdRow.status == 2
                              ? '進行中'
                              : selectedAdRow.status == 3
                                ? '已結束'
                                : '-'
                        }}</span>
                      </el-tag>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-card>

                <el-form
                  ref="adPositionForm"
                  :model="formAdPositionData"
                  :disabled="selectedAdRow.status == 3"
                >
                  <el-form-item
                    label="廣告版位"
                    :label-width="formLabelWidth"
                    prop="slotId"
                    :rules="[
                      {
                        required: true,
                        message: '請選擇廣告版位',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <!-- <el-select v-model="formAdPositionData.slotId" class="w-full-select">
                      <el-option v-for="slotItem in handleFormatSlotOptions()" :key="slotItem.id"
                        :label="`${slotItem.project} - ${slotItem.name}`" :value="slotItem.id"
                        :disabled="slotItem.disabled"></el-option>
                    </el-select> -->
                    <el-radio-group v-model="formAdPositionData.slotId">
                      <el-radio-button
                        v-for="slotItem in handleFormatSlotOptions(selectedAdRow.slot)"
                        :key="slotItem.id"
                        :label="slotItem.id"
                        :disabled="slotItem.disabled || !!formAdPositionData.id"
                      >
                        {{ `${slotItem.project} - ${slotItem.name}` }}</el-radio-button
                      >
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    label="廣告排序"
                    :label-width="formLabelWidth"
                    prop="priority"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入廣告排序',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formAdPositionData.priority" autocomplete="off" />
                  </el-form-item>

                  <el-form-item
                    label="廣告連結"
                    :label-width="formLabelWidth"
                    prop="link"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入廣告連結',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formAdPositionData.link" autocomplete="off" />
                  </el-form-item>

                  <!-- <el-form-item label="顯示描述頁" :label-width="formLabelWidth" prop="showDescriptionPage">
                    <el-switch v-model="formAdPositionData.showDescriptionPage" active-text="是" inactive-text="否">
                    </el-switch>
                  </el-form-item> -->
                  <!--  1024x768 4:3 -->
                  <!-- APP 推薦商家 500x500 1:1 -->
                  <!-- 熱門文章、搜尋頁 1080x605 16:9 -->
                  <!-- 下方 1024x437 21:9 -->
                  <el-form-item prop="fileInfo" style="margin-bottom: 30px">
                    <Upload
                      ref="uploadRef"
                      :require="true"
                      :limit-file-count="1"
                      :payload="formAdPositionData"
                      :accept="'.jpg,.jpeg,.png'"
                      :data-obj="{ id: 42, type: 'adSlot' }"
                      :use-drag="false"
                      :action="'file/fileUploadAd'"
                      :auto-upload="false"
                      :show-file-list="true"
                      :form-on-loading-parent="formLoading"
                      :btn-txt="'上傳'"
                      :before-file-list="
                        formAdPositionData.fileInfo && formAdPositionData.fileInfo.length
                          ? formAdPositionData.fileInfo[0].files
                          : []
                      "
                      :limitText="
                        formAdPositionData.slotId
                          ? `顯示圖片最佳尺寸為${formAdPositionData.slotId == 3 ? '1024x437 (21:9)' : formAdPositionData.slotId == 4 ? '500x500（1:1）' : '1080x605 (16:9)'}大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB`
                          : null
                      "
                    />
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
            <el-col :span="12" v-if="false">
              <div>
                <p>當前版位列表</p>
                <el-table :data="selectedAdRow.slot" border fit size="small">
                  <el-table-column align="center" label="版位" prop="slotId">
                    <template slot-scope="scope">
                      {{ handleFormatSlotTitle(scope.row.slotId) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="封面圖">
                    <template slot-scope="scope">
                      <el-image
                        style="height: 100px"
                        v-if="scope.row.fileInfo"
                        :src="
                          scope.row.fileInfo.url
                            ? scope.row.fileInfo.url
                            : 'https://fakeimg.pl/300x300/'
                        "
                        fit="contain"
                        :preview-src-list="[scope.row.fileInfo.url]"
                        :lazy="true"
                      >
                      </el-image>
                      <el-image
                        style="height: 100px"
                        v-else
                        :src="'https://fakeimg.pl/300x300/'"
                        fit="contain"
                        :preview-src-list="['https://fakeimg.pl/300x300/']"
                        :lazy="true"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="80" label="排序" prop="priority" />
                  <!-- <el-table-column align="center" width="100" label="顯示描述頁" prop="showDescriptionPage">
                    <template slot-scope="scope">
                      {{ scope.row.showDescriptionPage ? '是' : '否' }}
                    </template>
                  </el-table-column> -->
                  <el-table-column align="center" width="180" label="連結" prop="link">
                    <template slot-scope="scope">
                      <a :href="scope.row.link" target="_blank" style="color: #1890ff">{{
                        scope.row.link
                      }}</a>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <div slot="footer" class="dialog-footer">
          <el-button
            v-if="selectedAdRow.status != 3"
            type="warning"
            @click="saveData('asPositionFormData')"
            style="color: #4b4b4b"
            >儲 存</el-button
          >

          <el-button
            @click="dialogAdSlotVisible = false"
            :type="selectedAdRow.status == 3 ? 'danger' : ''"
          >
            {{ selectedAdRow.status == 3 ? '關 閉' : '取 消' }}
          </el-button>
        </div>
      </el-dialog>

      <el-form :inline="true" class="filter-form" @submit.native.prevent>
        <el-form-item label="查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入商家/廣告名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>
        <el-button
          type="primary"
          @click="getList"
          icon="el-icon-search"
          circle
          style="margin-top: 8px; margin-left: 5px"
          :disabled="listLoading"
        ></el-button>
        <el-button
          type="warning"
          @click="editCompanyData({ id: null })"
          circle
          icon="el-icon-plus"
          :disabled="listLoading"
        ></el-button>
        <el-button
          style="cursor: pointer"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>
        <CompanyList class="company-list" />
      </el-form>

      <div style="position: relative; height: 80%">
        <el-table
          ref="formDetailsTable"
          v-loading="listLoading"
          :data="list"
          border
          fit
          size="small"
          highlight-current-row
          style="width: 100%"
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column align="center" label="數量" width="1" type="expand">
            <template slot-scope="scope">
              <div style="margin: 8px 0">
                <el-table
                  size="small"
                  border
                  fit
                  :data="scope.row.advertise"
                  style="width: 100%"
                  height="360"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column align="center" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="travelName1" label="廣告方案" width="400">
                    <template slot-scope="scope">
                      <div>
                        <strong>{{ scope.row.name }}</strong>
                        <br />
                        {{ scope.row.subTitle }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="180" label="廣告日期">
                    <template slot-scope="scope">
                      <span>{{ `${scope.row.startDate} 至 ${scope.row.endDate}` }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="90" label="狀態">
                    <template slot-scope="scope">
                      <el-tag
                        :type="
                          scope.row.status == 1
                            ? 'warning'
                            : scope.row.status == 2
                              ? 'success'
                              : scope.row.status == 3
                                ? 'info'
                                : 'danger'
                        "
                      >
                        <span>{{
                          scope.row.status == 1
                            ? '未開始'
                            : scope.row.status == 2
                              ? '進行中'
                              : scope.row.status == 3
                                ? '已結束'
                                : '-'
                        }}</span>
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="270" label="編輯版位">
                    <template slot-scope="scope">
                      <div
                        v-for="currentAdSlot in scope.row.slot"
                        :key="currentAdSlot.id"
                        style="padding: 4px 0"
                      >
                        <el-tag
                          size="small"
                          @click="editAdSlotData(scope.row.id, currentAdSlot)"
                          style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            cursor: pointer;
                          "
                        >
                          <div style="display: flex; gap: 0 8px; align-items: center">
                            <div @click.stop>
                              <el-image
                                @click.prevent
                                :src="
                                  currentAdSlot.fileInfo
                                    ? currentAdSlot.fileInfo.url
                                    : 'https://fakeimg.pl/60/60'
                                "
                                style="height: 60px; width: 60px; border-radius: 10px"
                                fit="contain"
                                :preview-src-list="[
                                  currentAdSlot.fileInfo
                                    ? currentAdSlot.fileInfo.url
                                    : 'https://fakeimg.pl/60/60',
                                ]"
                                :lazy="true"
                              ></el-image>
                            </div>
                            <span>{{ handleFormatSlotTitle(currentAdSlot.slotId) }}</span>
                          </div>
                          <div>
                            <el-button icon="el-icon-edit" circle type="text"> </el-button>
                          </div>
                        </el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="140" label="新增版位">
                    <template slot-scope="scope">
                      <div>
                        <el-button
                          size="mini"
                          type="warning"
                          circle
                          icon="el-icon-plus"
                          :disabled="
                            scope.row.status == 3 || (scope.row.slot && scope.row.slot.length >= 4)
                          "
                          @click="editAdSlotData(scope.row.id)"
                        ></el-button>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="140" label="編輯廣告">
                    <template slot-scope="scope">
                      <div>
                        <el-button
                          size="mini"
                          :type="scope.row.status == 3 ? '' : 'success'"
                          circle
                          :icon="scope.row.status == 3 ? 'el-icon-view' : 'el-icon-edit'"
                          @click="editAdData(scope.row.id, false, scope.row.status == 3)"
                        ></el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="商家 LOGO" width="100">
            <template slot-scope="scope">
              <img
                style="
                  height: 60px;
                  width: 60px;
                  border-radius: 50%;
                  border: 1px solid #ddd;
                  object-fit: cover;
                "
                v-if="!!scope.row.fileInfo && !!scope.row.fileInfo.url"
                :src="scope.row.fileInfo.url"
              />
              <!-- <el-image style="height: 60px;width:60px;border-radius: 50%;border:1px solid #ddd;"
                v-if="scope.row.fileInfo" :src="scope.row.fileInfo.url
                  ? scope.row.fileInfo.url
                  : 'https://fakeimg.pl/300/300'
                  " fit="cover" :preview-src-list="[scope.row.fileInfo.url]" :lazy="true">
              </el-image> -->
              <el-image
                style="height: 60px; width: 60px; border-radius: 50%; border: 1px solid #ddd"
                v-else
                :src="'https://fakeimg.pl/300x300/'"
                fit="cover"
                :preview-src-list="['https://fakeimg.pl/300/300']"
                :lazy="true"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="商家名稱" width="480">
            <template slot-scope="{ row }">
              <el-popover placement="right" width="400" trigger="hover">
                <el-descriptions
                  class="margin-top"
                  title="商家詳情"
                  :column="1"
                  size="small"
                  border
                >
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-office-building"></i>
                      商家名稱
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.name"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.name }}
                      </span>
                      <div class="copy-icon" v-show="!!row.name">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-tickets"></i>
                      統一編號
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.vatNumber"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.vatNumber }}
                      </span>
                      <div class="copy-icon" v-show="!!row.vatNumber">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-user"></i>
                      負責人
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.boss"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.boss }}
                      </span>
                      <div class="copy-icon" v-show="!!row.boss">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-message"></i>
                      E-mail
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.email"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.email }}
                      </span>
                      <div class="copy-icon" v-show="!!row.email">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-mobile-phone"></i>
                      電話
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.tel"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.tel }}
                      </span>
                      <div class="copy-icon" v-show="!!row.tel">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-location-outline"></i>
                      地址
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.address"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <span>
                        {{ row.address }}
                      </span>
                      <div class="copy-icon" v-show="!!row.address">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-time"></i>
                      簽約日期
                    </template>
                    <el-tag size="small">
                      {{ `${row.startDate} 至 ${row.endDate}` }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item>
                    <template slot="label">
                      <i class="el-icon-location-outline"></i>
                      官方網址
                    </template>
                    <div
                      class="copy-container"
                      v-clipboard:copy="row.url"
                      v-clipboard:success="clipboardSuccess"
                    >
                      <a :href="row.url" @click.capture target="_blank" style="color: #1890ff">{{
                        row.url
                      }}</a>
                      <div class="copy-icon" v-show="!!row.url">
                        <el-icon name="document-copy"> </el-icon>
                      </div>
                    </div>
                  </el-descriptions-item>
                </el-descriptions>
                <div
                  style="cursor:pointer;hover:opacity:75%;width:fit-content"
                  slot="reference"
                  @click="toggleExpand(row)"
                >
                  <span style="text-decoration: underline; font-weight: 500">
                    {{ row.name }}
                  </span>
                  <br />
                  <span style="color: #939393">
                    {{ `${row.startDate} 至 ${row.endDate}` }}
                  </span>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="簽約日期" width="180">
            <template slot-scope="{row}">
              <span>{{
                `${row.startDate} 至 ${row.endDate}`
              }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" width="90" label="簽約狀態">
            <template slot-scope="scope">
              <!-- <p :style="{ color: handleStatus(scope.row.startDate, scope.row.endDate).color }">
                {{
                  handleStatus(scope.row.startDate, scope.row.endDate).text }}
              </p> -->

              <el-tag
                size="small"
                :type="handleStatus(scope.row.startDate, scope.row.endDate).type"
              >
                <span> {{ handleStatus(scope.row.startDate, scope.row.endDate).text }}</span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="廣告數量">
            <el-table-column align="center" label="未開始" width="90">
              <template slot-scope="scope">
                <div
                  @click="toggleExpand(scope.row)"
                  style="font-size: 15px; font-weight: bold; cursor: pointer"
                >
                  <strong style="color: #ffba00">{{ handleCount(scope.row.advertise, 1) }} </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="進行中" width="90">
              <template slot-scope="scope">
                <div
                  @click="toggleExpand(scope.row)"
                  style="font-size: 15px; font-weight: bold; cursor: pointer"
                >
                  <strong style="color: #42b983">
                    {{ handleCount(scope.row.advertise, 2) }}
                  </strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="已結束" width="90">
              <template slot-scope="scope">
                <div
                  @click="toggleExpand(scope.row)"
                  style="font-size: 15px; font-weight: bold; cursor: pointer"
                >
                  <strong style="color: gray">
                    {{ handleCount(scope.row.advertise, 3) }}
                  </strong>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column align="center" label="廣告數量" width="200">
      <template slot-scope="scope">
        <div @click="toggleExpand(scope.row)" style="font-size: 15px; font-weight: bold; cursor: pointer">
          <el-tag type="warning">{{ handleCount(scope.row.advertise, 1) }}
          </el-tag>
          <span style="font-weight: normal"> / </span>
          <el-tag type="success">
            {{ handleCount(scope.row.advertise, 2) }}
          </el-tag>
          <span style="font-weight: normal"> / </span>
          <el-tag type="info">
            {{ handleCount(scope.row.advertise, 3) }}
          </el-tag>
        </div>
      </template>
    </el-table-column> -->

          <el-table-column align="center" label="操作" width="280" prop="satisfactionAnalysis">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="editCompanyData(scope.row)"
                >編輯</el-button
              >
              <el-button size="mini" type="primary" @click="exportPdf">匯出資料</el-button>
              <el-button size="mini" type="warning" @click="editAdData(scope.row.id)"
                >新增廣告</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Upload from '@/views/ita/components/fileUpload.vue'
import CompanyList from '@/views/ita/advertisement/components/companyList.vue'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  getCustomerCompaniesFullData,
  getAdvertisementsManagement,
  setCustomerCompaniesManagement,
  getSlotsManagement,
  setAdvertisementsManagement,
  setAdvertisementSlotMappings,
} from '@/api/advertisement'
import { Message } from 'element-ui'
import clipboard from '@/directive/clipboard/index.js' // use clipboard by v-directive
import dayjs from 'dayjs'
var defaultCompanyFormData = {
  id: null,
  name: null,
  vatNumber: null,
  boss: null,
  email: null,
  tel: null,
  address: null,
  signDate: null,
  startDate: null,
  endDate: null,
  url: null,
  fileInfo: [],
}

export default {
  name: 'AdvertisementDataTable',
  directives: {
    clipboard,
  },
  components: { Upload, Pagination, CompanyList },

  data() {
    return {
      signDate: '',
      adDate: '',
      pattern: {
        email:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        tel: /^09[0-9]{8}$/,
      },
      selectedLeaderUserID: null,
      dialogAdViewVisible: false,
      formLabelWidth: '120px',
      formData: {},
      formAdPositionData: {
        id: null,
        adId: null,
        slotId: null,
        priority: null,
        showDescriptionPage: true,
        link: null,
        fileInfo: [
          {
            fileName: null,
            base64: null,
          },
        ],
        adInfo: {},
      },
      dialogFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      selectedRow: {},
      selectedAdRow: {},
      drawerCompanyVisible: false,
      dialogAdSlotVisible: false,
      slotOptions: [],
      adFormData: {
        id: null,
        cId: null,
        name: null,
        subTitle: null,
        description: null,
        adDate: null,
        startDate: null,
        endDate: null,
        enable: true,
        // slot: {
        //   id: null,
        //   slotId: null,
        //   priority: 0,
        //   showDescriptionPage: true,
        //   link: null,
        //   fileInfo: {
        //     type: null,
        //     files: [{
        //       fileName: null,
        //       base64: null,
        //     }]
        //   }
        // },
      },
    }
  },
  async created() {
    const q = this.$route.query.q
    if (q) {
      this.listQuery.qry = q
    }
    await this.getList()
    await this.handleGetSlots()
  },
  methods: {
    // signDateTrigger(date) {
    //   console.log('signDateTrigger', date);
    //   this.$forceUpdate();
    //   this.formData.signDate =date;
    // },
    // adDateTrigger(date) {
    //   console.log('adDateTrigger', date);
    //   this.$forceUpdate();
    //   this.adFormData.adDate = date;
    // },
    async refresh() {
      this.defaultListQuerySetting()
      await this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      debugger
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    toggleExpand(row) {
      console.log('toggleExpand', row)
      let $table = this.$refs.formDetailsTable
      $table.toggleRowExpansion(row)
    },
    tableRowClassName({ row, rowIndex }) {
      return 'success-row'
    },

    defaultListQuerySetting() {
      this.listQuery = {
        qry: '',
        agencyCode: this.agencyCode,
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },

    formOnLoading() {
      this.formLoading = true
    },

    async editCompanyData(row) {
      let companyForm = this.$refs['companyForm']
      if (companyForm) {
        companyForm.clearValidate()
      }
      let refUpload = this.$refs['uploadLogoRef']
      if (refUpload) {
        refUpload.clearFiles()
      }
      this.formData = JSON.parse(JSON.stringify(row))
      if (this.formData.startDate) {
        this.$set(this.formData, 'signDate', [this.formData.startDate, this.formData.endDate])
        // this.formData.signDate = [this.formData.startDate, this.formData.endDate]
      }
      if (this.formData.fileInfo) {
        this.formData.fileInfo = [
          {
            files: [this.formData.fileInfo],
          },
        ]
        console.log('rs', this.formData.fileInfo)
      }
      this.dialogFormVisible = true
    },

    exportPdf() {
      // TODO: 匯出資料
      alert('匯出資料 x')
    },

    async saveData(formName) {
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      if (formName === 'companyFormData') {
        this.handleSaveCompanyData()
      }
      if (formName === 'adFormData') {
        this.handleSaveAdData()
      }
      if (formName === 'asPositionFormData') {
        this.handleSaveAdPositionData()
      }
    },
    handleFormatSlotTitle(slotId) {
      const item = this.slotOptions.find(slotItem => slotItem.id == slotId)
      return item ? `[${item.type == 2 ? '免費' : '付費'}] ${item.project} - ${item.name}` : null
    },
    handleFormatSlotOptions(slot) {
      const selectedSlots = slot ? slot : []
      if (selectedSlots.length > 0) {
        const selectedIds = selectedSlots ? selectedSlots.map(item => item.slotId) : []
        const formatOptions = this.slotOptions.map(slotItem => {
          return {
            ...slotItem,
            disabled: selectedIds.includes(slotItem.id),
          }
        })
        return formatOptions
      }
      return this.slotOptions
    },

    handleStatus(startDate, endDate) {
      const today = dayjs()
      if (today.isAfter(startDate) && today.isBefore(endDate)) {
        return {
          text: '進行中',
          type: 'success',
          color: '#42b983',
        }
      }
      if (today.isBefore(startDate)) {
        return {
          text: '未生效',
          type: 'warning',
          color: '#ffba00',
        }
      }
      if (today.isAfter(endDate)) {
        return {
          text: '已失效',
          type: 'info',
          color: 'gray',
        }
      }
      // 添加默認返回值
      return {
        text: '無效狀態',
        type: 'danger',
        color: 'red',
      }
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      await getCustomerCompaniesFullData(this.listQuery)
        .then(response => {
          this.list = response.data.data
          this.total = response.data.total
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.listLoading = false
          this.drawerCompanyVisible = false
        })
    },
    handleShowDetail(row) {
      this.selectedRow = row
      this.drawerCompanyVisible = true
    },
    handleCount(ad, status) {
      let val = 0
      if (ad && ad.length > 0) {
        const data = ad.filter(item => item.status == status)
        val = data.length || 0
      }
      return val
    },
    editData(d) {
      this.formData = JSON.parse(JSON.stringify(d))
      this.dialogFormVisible = true
    },
    clipboardSuccess() {
      this.$message({
        message: '複製成功！',
        type: 'success',
        duration: 1500,
      })
    },
    // 編輯廣告
    async editAdData(cid, createMode = true, viewOnly = false) {
      if (createMode) {
        this.adFormData = {
          cid: cid,
          name: null,
          subTitle: null,
          description: null,
          adDate: null,
          startDate: null,
          endDate: null,
          enable: true,
          code: null,
        }
        this.dialogAdViewVisible = true
      } else {
        this.listLoading = true
        await getAdvertisementsManagement(cid)
          .then(response => {
            this.adFormData = JSON.parse(JSON.stringify(response.data))
            if (this.adFormData.startDate) {
              this.$set(this.adFormData, 'adDate', [
                this.adFormData.startDate,
                this.adFormData.endDate,
              ])
              // this.adFormData.adDate = [this.adFormData.startDate, this.adFormData.endDate]
            }
            this.dialogAdViewVisible = true
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => {
            this.listLoading = false
          })
      }
    },

    // 開啟彈窗 - 新增/編輯廣告綁定版位
    editAdSlotData(id, slot = {}) {
      const vm = this
      vm.listLoading = true
      let adPositionForm = this.$refs['adPositionForm']
      if (adPositionForm) {
        adPositionForm.clearValidate()
      }
      let refUpload = this.$refs['uploadRef']
      if (refUpload) {
        refUpload.clearFiles()
      }
      getAdvertisementsManagement(id)
        .then(response => {
          vm.selectedAdRow = response.data
          console.log('vm.selectedAdRow', vm.selectedAdRow)
          this.formAdPositionData = JSON.parse(JSON.stringify(slot))
          console.log('formAdPositionData', this.formAdPositionData)
          this.formAdPositionData.adId = vm.selectedAdRow.id
          this.formAdPositionData.fileInfo = [{ files: [this.formAdPositionData.fileInfo] }]
          vm.dialogAdSlotVisible = true
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          vm.listLoading = false
        })
    },

    // 新增/編輯商家
    async handleSaveCompanyData() {
      const vm = this

      this.$refs['companyForm'].validate(async valid => {
        if (valid) {
          let refUpload = this.$refs['uploadLogoRef']
          let payload = await refUpload.combineFileAndPayload()
          vm.formData.startDate = vm.formData.signDate[0]
          vm.formData.endDate = vm.formData.signDate[1]
          const { fileIDs, fileInfo, signDate, advertise, ...rest } = vm.formData
          const imgFile = payload.fileInfo[0].files[0]
          const params = { fileInfo: imgFile, ...rest }
          vm.formLoading = true
          await setCustomerCompaniesManagement(params)
            .then(async response => {
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })

              // if (!vm.formData.id) {
              //   vm.listQuery.qry = vm.formData.name
              // }
              await vm.getList()
              vm.formLoading = false
              vm.dialogFormVisible = false
            })
            .catch(e => {
              vm.dialogFormVisible = false
              vm.formLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 刪除廣告
    handleAdDelete() {},

    // 新增/編輯廣告
    handleSaveAdData() {
      const vm = this
      this.$refs['adForm'].validate(async valid => {
        if (valid) {
          vm.adFormData.startDate = vm.adFormData.adDate[0]
          vm.adFormData.endDate = vm.adFormData.adDate[1]
          const { adDate, advertise, ...params } = vm.adFormData
          vm.formLoading = true
          await setAdvertisementsManagement(params)
            .then(async response => {
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
              await vm.getList()
              vm.formLoading = false
              vm.dialogAdViewVisible = false
            })
            .catch(e => {
              vm.formLoading = false
            })
        } else {
          return false
        }
      })
    },
    // 保存新增/編輯廣告版位
    async handleSaveAdPositionData() {
      const vm = this
      this.$refs['adPositionForm'].validate(async valid => {
        if (valid) {
          let refUpload = this.$refs['uploadRef']
          let payload = await refUpload.combineFileAndPayload()
          const { fileIDs, fileInfo, showCount, ...rest } = vm.formAdPositionData
          const imgFile = payload.fileInfo[0].files[0]
          const params = { fileInfo: imgFile, ...rest }
          vm.formLoading = true
          await setAdvertisementSlotMappings(params)
            .then(async response => {
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
              await vm.getList()
              vm.formLoading = false
              vm.dialogAdSlotVisible = false
            })
            .catch(e => {
              vm.formLoading = false
            })
        } else {
          return false
        }
      })
    },

    async handleGetSlots() {
      this.listLoading = true
      const params = {
        qry: '',
        status: 1,
        page: 1,
        limit: 1000,
        sort: '-id',
      }
      getSlotsManagement(params)
        .then(response => {
          this.slotOptions = response.data.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
  },
}
</script>
<style>
.el-dialog__body {
  padding: 15px;
}
</style>

<style lang="scss" scoped>
.company-list {
  display: inline-block;
  margin-left: 10px;
}

.copy-container {
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  gap: 0 0.5rem;
  align-items: center;
}

.copy-container:hover .copy-icon {
  opacity: 1;
  /* 這裡可以調整懸停時的透明度 */
}

.copy-icon {
  opacity: 0;
  /* 初始化為隱藏狀態 */
}

.copy-icon el-icon {
  text-decoration: underline;
  font-weight: 500;
}

.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 15px !important;
}

.w-full-date {
  width: 100%;
}

.w-full-select {
  width: 100%;
}
</style>
